import { uploadUrl } from "./assets";
import { CONTACT_EMAIL } from "../data/contact";

/** @typedef {import("../data/photography").Photo} Photo */

/** @param {Photo} photo */
export function photoBackground(photo) {
  if (photo.src) {
    const focusX = photo.focusX ?? 50;
    const focusY = photo.focusY ?? 50;
    return `url('${uploadUrl(photo.src)}') ${focusX}% ${focusY}% / cover`;
  }
  return photo.grad ?? "#161412";
}

/** @param {Photo} photo */
export function keywordLine(photo) {
  const keywords = photo.kw?.length ? photo.kw : [photo.cap];
  return keywords.map((item) => item.toUpperCase()).join("  ·  ");
}

/** @param {Photo} photo */
export function lightboxDescription(photo) {
  if (photo.desc) return photo.desc;
  if (photo.loc) {
    return photo.yr ? `${photo.loc} · ${photo.yr}` : photo.loc;
  }
  return "";
}

/** @param {number} width */
export function masonryColumnCount(width) {
  if (width < 560) return 1;
  if (width < 900) return 2;
  if (width < 1240) return 3;
  return 4;
}

/** @param {Photo} photo */
export function buyMailtoHref(photo) {
  const subject = encodeURIComponent(`Print enquiry: ${photo.t}`);
  const body = encodeURIComponent(
    `Hi CJ,\n\nI'd like to enquire about acquiring "${photo.t}" as a print or digital file. Could you send sizes, pricing and availability?\n\nThanks,`
  );
  return `mailto:${CONTACT_EMAIL}?subject=${subject}&body=${body}`;
}
